import { render, staticRenderFns } from "./mdInfoBoard.vue?vue&type=template&id=b6e07d48&scoped=true&"
import script from "./mdInfoBoard.vue?vue&type=script&lang=js&"
export * from "./mdInfoBoard.vue?vue&type=script&lang=js&"
import style0 from "./mdInfoBoard.vue?vue&type=style&index=0&id=b6e07d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e07d48",
  null
  
)

export default component.exports